"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DesetiletiCistotyADuvery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const stats = [{
    value: "10+",
    label: "Let profesionální praxe"
  }, {
    value: "100%",
    label: "Certifikovaná hygiena"
  }, {
    value: "Praha a střední Čechy",
    label: "LOKÁLNÍ CENTRÁLA PRAHA VRŠOVICE"
  }];
  return <section id="desetiletí-čistoty-a-důvěry" ref={ref} className={`w-full bg-muted/30 border-y border-border/40 py-10 transition-opacity duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <h2 className="sr-only">Desetiletí čistoty a důvěry</h2>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-center md:justify-evenly gap-8 md:gap-0">
          {stats.map((stat, index) => <React.Fragment key={index}>
              <div data-index={index} className="flex flex-col items-center text-center px-4">
                <span className="text-4xl md:text-5xl font-bold text-primary mb-2 tracking-tight">
                  {stat.value}
                </span>
                <span className="text-sm md:text-base font-medium uppercase tracking-wider text-chart-2">
                  {stat.label}
                </span>
              </div>

              {}
              {index < stats.length - 1 && <>
                  {}
                  <div className="hidden md:block h-16">
                    <Separator orientation="vertical" className="bg-border/60" />
                  </div>
                  
                  {}
                  <div className="block md:hidden w-24">
                    <Separator orientation="horizontal" className="bg-border/60" />
                  </div>
                </>}
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}